export const AP_NAVIGATION_LOADER = {
  desktop: `<div class="cui-container -spacing--top-16 -spacing--bottom-16">
  <div class="cui-skeleton__item" style="width: 110px; height: 20px; display: inline-block; margin-right: 40px;"></div>
  <div class="cui-skeleton__item" style="width: 110px; height: 20px; display: inline-block; margin-right: 40px;"></div>
  <div class="cui-skeleton__item" style="width: 110px; height: 20px; display: inline-block; margin-right: 40px;"></div>
  <div class="cui-skeleton__item" style="width: 110px; height: 20px; display: inline-block; margin-right: 40px;"></div>
  <div class="cui-skeleton__item" style="width: 110px; height: 20px; display: inline-block; margin-right: 40px;"></div>
</div>`
};
